<template>
  <div
    :class="questionListTotal > 1 ? 'wrong-question-padding' : 'wrong-question'"
    v-if="show"
  >
    <div class="header-warp">
      <div class="number-warp">
        <span class="now-number">{{ questionIndex + 1 }}/</span>
        <span>{{ questionListTotal }}</span>
      </div>
      <p class="createdAt-text">{{ questionList[questionIndex].createdAt }}</p>
    </div>
    <div class="question-warp">
      <div class="question-title" v-html="talqsHtml"></div>
      <div class="answer-button" @click="showAnswer()">
        {{ questionList[questionIndex].isAnswerShow ? "收起答案" : "答案解析" }}
      </div>
    </div>
    <div
      v-html="analysis"
      class="talqs answer-warp"
      v-show="questionList[questionIndex].isAnswerShow"
    ></div>
    <div class="footer-warp" v-if="questionListTotal > 1">
      <div
        :class="
          questionIndex == questionListTotal - 1
            ? 'footer-button-only'
            : 'footer-button footer-button-last'
        "
        v-if="questionIndex"
        @click="last()"
      >
        <img
          :src="
            questionIndex == questionListTotal - 1
              ? whiteLeftArrow
              : blackLeftArrow
          "
          alt=""
          class="footer-button-last-img"
        />
        <span>上一题</span>
      </div>
      <div
        :class="
          questionIndex == 0
            ? 'footer-button-only'
            : 'footer-button footer-button-next'
        "
        v-if="questionIndex < questionListTotal - 1"
        @click="next()"
      >
        <span>下一题</span>
        <img
          src="@/assets/img/wrongQuestion/whiteright-arrow.png"
          alt=""
          class="footer-button-next-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import whiteLeftArrow from "@/assets/img/wrongQuestion/whiteleft-arrow.png";
import blackLeftArrow from "@/assets/img/wrongQuestion/blackleft-arrow.png";
import { loadStyle, loadScript } from "../../utils/utils";
export default {
  name: "wrongquestion",
  data() {
    return {
      show: false,
      whiteLeftArrow,
      blackLeftArrow,
      questionList: [
        {
          id: "",
          content: "",
          answerOptionList: [],
          answer: [],
          analysis: null,
          createdAt: "",
          isAnswerShow: false,
        },
      ],
      questionListTotal: null,
      questionIndex: 0,
      talqsHtml: "",
      analysis: "",
    };
  },
  methods: {
    getQueryString(name, search) {
      search =
        search ||
        window.location.search.substr(1) ||
        window.location.hash.split("?")[1];
      if (!search) return null;
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = search.match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    showAnswer() {
      let answer = document.getElementsByClassName("talqs_label")[0];
      let analysis = document.getElementsByClassName("talqs_label")[1];
      answer.innerHTML = "正确答案";
      analysis.innerHTML = "答案解析";
      this.questionList[this.questionIndex].isAnswerShow =
        !this.questionList[this.questionIndex].isAnswerShow;
    },
    async getQuestion() {
      let res = await this.$api.question.queryNewQuestionListByIdList({
        class_batch_id: this.getQueryString("class_batch_id") || "",
        student_uid: this.getQueryString("student_uid") || "",
      });
      if (res.error_code == 0) {
        let questionList = res.result.list;
        this.questionListTotal = res.result.total;
        questionList.map((item) => {
          item.isAnswerShow = false;
        });
        this.questionList = questionList;
        this.initTalqsTemplate();
      } else {
        this.$toast(res.message);
      }
    },
    escape2Html(str) {
      let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    next() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.questionIndex++;
      this.initTalqsTemplate();
    },
    last() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.questionIndex--;
      this.initTalqsTemplate();
    },
    updateTemplate() {
      let talComponents = window.TalqsTemplate.components;
      window.TalqsTemplate.updateTemplateList({
        [talComponents.AnalyzeWrapper]: {
          exclude: [talComponents.QueID, talComponents.KnowledgePoint], // 移出试题 ID 组件
        },
      });
    },
    initTalqsTemplate() {
      this.updateTemplate();
      this.talqsHtml = window.TalqsTemplate.render(
        this.questionList[this.questionIndex],
        {
          hideSource: true,
          hideDifficulty: true,
          entryTemplate: window.TalqsTemplate.components.Question,
        }
      );
      this.analysis = this.escape2Html(
        window.TalqsTemplate.render(this.questionList[this.questionIndex], {
          analyzeVersion: 2,
          entryTemplate: window.TalqsTemplate.components.AnalyzeWrapper,
          separator: {
            0: [" ; ", " 或 "],
          },
        })
      );
      this.show = true;
    },
  },
  mounted() {
    let _this = this;
    loadScript(
      "https://static1.izhikang.com/webresource/usertech-public/js/jquery.min.js",
      () => {
        loadScript(
          "https://static.speiyou.com/library/MathJax/2.7.4.1/MathJax.js",
          () => {
            loadScript(
              "https://static.speiyou.com/library/talqs-template4.0/1.0.5/talqsTemplate.min.js",
              () => {
                _this.getQuestion();
                _this.$nextTick(() => {
                  window.TalqsTemplate.autoLayout();
                  window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
                });
              }
            );
          }
        );
      }
    );
    loadStyle(
      "https://static.speiyou.com/library/talqs-template4.0/1.0.5/talqsTemplate.min.css"
    );
  },
};
</script>;
<style lang="scss">
.wrong-question {
  svg {
    overflow: visiable;
  }
}
.talqs > .talqs_main > .talqs_content {
  margin-bottom: 20px;
  p {
    font-size: 16px;
    font-weight: 600;
    color: #000c1d;
    line-height: 22.5px !important;
  }
  font-size: 0.42667rem;
  font-weight: 600;
  color: #000c1d;
  line-height: 0.6rem !important;
  // margin-left: 20px;
}
.talqs > .talqs_main > .talqs_subqs {
  .talqs_main {
    margin-bottom: 14px;
  }
  .talqs_content {
    font-size: 0.42667rem;
    font-weight: 600;
    color: #000c1d;
    line-height: 0.6rem !important;
    margin-left: 20px;
  }
  .talqs_index {
    float: left;
    font-size: 0.42667rem;
    font-weight: 600;
    color: #000c1d;
    line-height: 0.6rem !important;
  }
}
.talqs .talqs_options ul {
  .talqs_options_columns_1 {
    margin-bottom: 14px;
    li {
      line-height: 16px;
      .talqs_options_label {
        float: left;
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        display: block;
      }
      .talqs_options_content {
        margin-left: 20px;
        line-height: 16px;
        p,
        .mathjax_content {
          line-height: 16px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
  .talqs_options_rows {
    line-height: 16px;
    margin-bottom: 14px;
    .talqs_options_index {
      float: left;
      height: 16px !important;
      line-height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      display: block;
    }
    .talqs_options_columns_4 ,.talqs_options_columns_3 {
      .talqs_options_columns_item {
          margin-bottom: 3px;
        .talqs_options_label {
          line-height: 16px;
          font-size: 16px;
          color: #333333;
        }
        .talqs_options_content {
          margin-left: 20px;
          line-height: 16px;
          font-size: 16px;
          color: #333333;

          p,
          .mathjax_content {
            line-height: 16px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
}
.talqs .talqs_analyze_group {
  background-color: #ffffff !important;
  border: none !important;
  padding: 0 !important;
  margin-top: 0 !important;
  .talqs_label {
    display: block;
    background-color: #ffffff !important;
    float: unset !important;
    color: #333333 !important;
    text-align: left !important;
    padding: 0 !important;
    position: relative;
    height: 18px;
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
    padding-left: 10px !important;
    margin-bottom: 16px;
    width: 100%;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 18px;
      background: #e02727;
      border-radius: 2px;
    }
  }
}
.talqs .talqs_answer_group .talqs_panel,
.talqs .talqs_analyze_group .talqs_panel {
  margin-left: 0 !important;
  padding-bottom: 20px;
  padding-right: 0 !important;
  .talqs_analyze_item {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 14px;
    .talqs_panel_item_content {
      // font-size: 16px !important;
      // font-weight: 400;
      // color: #333333;
      line-height: 22.5px;
      p {
        line-height: 22.5px;
      }
    }
  }
  .talqs_analyze_item_index {
    line-height: 22.5px;
  }
}
.talqs .talqs_analyze_group .talqs_answer .talqs_panel .talqs_panel_item {
  .talqs_panel_item_content {
    font-size: 16px !important;
    font-weight: 400;
    color: #333333;
    line-height: 22.5px;
  }
  p {
    line-height: 22.5px;
  }
}
.talqs .talqs_analyze_group .talqs_panel {
  margin-left: 0 !important;
  padding-bottom: 20px;
  padding-right: 0 !important;
  .talqs_panel_item {
    .talqs_panel_item_content {
      font-size: 16px !important;
      font-weight: 400;
      color: #000c1d;
      line-height: 22.5px;
      p {
        line-height: 22.5px;
        margin-bottom: 5px !important;
        .mathjax_content {
          font-size: 16px !important;
        }
      }
    }
  }
}
.talqs .talqs_analyze_group .talqs_answer {
  border-bottom: 1px solid rgba(230, 230, 230, 0.54);
  margin-bottom: 20px !important;
}
</style>

<style lang="scss" scoped>
.wrong-question {
  overflow-y: scroll;
}
.wrong-question-padding {
  // height: 100%;
  overflow-y: scroll;
  padding-bottom: 84px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 84px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 84px);
}
.header-warp {
  width: 100%;
  height: 46px;
  background: #ffffff;
  position: relative;
  margin-bottom: 16px;
  .number-warp {
    position: absolute;
    left: 16px;
    top: 10px;
    width: 55.5px;
    height: 26px;
    background: #ffffff;
    border-radius: 13.5px;
    border: 1px solid rgba(175, 182, 191, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
    .now-number {
      color: #000000;
      margin-right: 4px;
    }
  }
  .createdAt-text {
    width: 100%;
    height: 46px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #9fa1a3;
    line-height: 46px;
  }
}
.question-warp {
  width: 100%;
  padding: 0 16px 20px;
  .answer-button {
    margin-top: 40.5px;
    width: 104px;
    height: 40px;
    background: #e02727;
    border-radius: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
  }
}
.answer-warp {
  width: 100%;
  overflow: auto;
  border-top: 8px solid #f7f8fa;
  padding: 20px 16px;
}
.footer-warp {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 64px;
  background: #ffffff;
  box-shadow: 0 1px 0 0 #f5f5f7;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  span {
    display: inline-block;
    font-size: 16px;
    line-height: 48px;
  }
  .footer-button-only {
    width: 343px;
    height: 48px;
    background: #e02727;
    border-radius: 24px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-button {
    width: 166.5px;
    height: 48px;
    border-radius: 24px;
    text-align: center;
    line-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-button-last {
    background: #ffffff;
    border: 1px solid #afb6bf;
    color: #000c1d;
    margin-right: 10px;
  }
  .footer-button-next {
    color: #ffffff;
    background: #e02727;
    border: 1px solid #e02727;
  }
  .footer-button-last-img {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
  .footer-button-next-img {
    width: 18px;
    height: 18px;
    margin-left: 4px;
  }
}
</style>
